module.exports = __webpack_public_path__ + "static/media/ct-60.0d14ad9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/ct-60.png
// module id = 90
// module chunks = 0